var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import { Component, Vue } from 'vue-property-decorator';
import { Room } from '@/models/Room';
import DataTable from '@/components/data-table/DataTable';
import PageHeader from '@/components/page-header/PageHeader';
import AddRoomDialog from '@/views/Rooms/AddRoomDialog';
import ErrorHandler from '@/support/ErrorHandler';
import { colorHtml } from '@/support/String';
let Rooms = class Rooms extends Vue {
    constructor() {
        super(...arguments);
        this.selected = [];
        this.room = new Room();
        this.selectedRoom = new Room();
        this.isCreatingRoom = false;
        this.isEditingRoom = false;
    }
    get tableOptions() {
        return {
            name: {
                singular: this.$tc('room.title', 1),
                plural: this.$tc('room.title', 2),
            },
            headers: [
                {
                    text: '',
                    value: 'color',
                    transform: colorHtml,
                },
                {
                    text: this.$t('name.title').toString(),
                    value: 'name',
                    action: '/rooms/{id}',
                },
                {
                    text: this.$t('table.maxCapacity').toString(),
                    value: 'capacity',
                },
            ],
            actions: [
                {
                    type: 'view',
                    label: 'view',
                    icon: 'remove_red_eye',
                    action: '/rooms/{id}',
                },
                {
                    type: 'delete',
                    label: 'delete',
                    icon: 'delete',
                    action: (vm, room) => {
                        this.handleTableDelete(room);
                    },
                },
            ],
            filters: [],
            dropdown: [],
            model: new Room(),
        };
    }
    get dialogOptions() {
        const room = this.selectedRoom;
        return {
            title: room.name || this.$t('dialogOptions.confirmation').toString(),
            text: this.$tc('dialogOptions.delete', 1, { item: this.$t('dialogOptions.item.room') }).toString(),
            type: 'warning',
            buttons: {
                confirm: {
                    text: this.$t('dialogOptions.button.delete').toString(),
                    action: () => {
                        if (!room) {
                            return;
                        }
                        room
                            .delete()
                            .then((response) => {
                            if (response) {
                                this.selectedRoom = new Room();
                                this.refreshDataTable();
                            }
                        })
                            .catch((error) => {
                            ErrorHandler.network(error);
                        });
                    },
                },
                cancel: {
                    text: this.$t('dialogOptions.button.cancel').toString(),
                    action: () => {
                        this.selectedRoom = new Room();
                    },
                },
            },
        };
    }
    handleTableEdit(room) {
        this.selectedRoom = room;
        this.isEditingRoom = true;
    }
    handleTableDelete(room) {
        this.selectedRoom = room;
        this.$store.dispatch('openDialog', this.dialogOptions);
    }
    refreshDataTable() {
        document.dispatchEvent(new CustomEvent('datatable:hook', {
            detail: (dataTable) => {
                dataTable.refresh();
            },
        }));
    }
    parseLessonTypes(room) {
        if (!room.lesson_types || room.lesson_types.length === 0) {
            return '-';
        }
        let typeString = '';
        for (let i = 0; i < room.lesson_types.length; i += 1) {
            const lesson_type = room.lesson_types[i];
            if (typeof lesson_type === 'string') {
                typeString += `${lesson_type}`;
            }
            else {
                typeString += `${lesson_type.name}`;
            }
            if (i < room.lesson_types.length - 1) {
                typeString += ', ';
            }
        }
        return typeString;
    }
};
Rooms = __decorate([
    Component({
        components: {
            DataTable,
            PageHeader,
            AddRoomDialog,
        },
    })
], Rooms);
export default Rooms;
